import React from 'react';
import { graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';

import Layout from '../components/Layout';
import Header from '../components/Header';
import Gallery from '../components/Gallery';
import Button from '../components/Button';
import ChevronDown from '../svg/icons/chevron-down.svg';

import {
  hero,
  logo,
  iconDown,
  about,
  information,
} from '../css/Home.module.css';

const Home = () => {
  const { t } = useTranslation();

  return (
    <Layout pageTitle={t('page-titles.home')}>
      <section className={hero}>
        <Header />
        <StaticImage src="../images/logo.png" alt="Shibuya" placeholder="transparent" className={logo} />
        <ChevronDown className={iconDown} />
      </section>
      <article className={about}>
        <h1>{t('about-us')}</h1>
        <p>{t('copy.about-us-line-1')}</p>
        <p>{t('copy.about-us-line-2')}</p>
        <p>{t('copy.about-us-line-3')}</p>
        <p>{t('copy.about-us-line-4')}</p>
        <p>{t('copy.about-us-line-5')}</p>
      </article>
      <article className={information}>
        <h1>{t('information')}</h1>
        <h3>{t('payment')}</h3>
        <p>{t('copy.payment-line-1')}</p>
        <h3>{t('timeslots')}</h3>
        <ul>
          <li>{t('copy.timeslot-1')}</li>
          <li>{t('copy.timeslot-2')}</li>
          <li>{t('copy.timeslot-3')}</li>
          <li>{t('copy.timeslot-4')}</li>
        </ul>
        <p>{t('copy.information-line-1')}</p>
        <p>{t('copy.information-line-2')}</p>
        <p>{t('copy.information-line-3')}</p>
      </article>
      <Gallery itemsToShow={4} />
      <Link to="/gallery">
        <Button labelText={t('view-gallery')} />
      </Link>
    </Layout>
  );
};

export default Home;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
